import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import DashHeader from "./DashHeader";
import { useDispatch, useSelector } from "react-redux";
import { getUserSMEDetails } from "../actions/userActions";
import RegComp from "./RegComp";
import LoginComp from "./LoginComp";
import RegCompSME from "./RegCompSME";
import { LinkContainer } from "react-router-bootstrap";

import axios from "axios";
import { Helmet } from "react-helmet-async";
function HealthCheckForm3() {
  const date = new Date().toDateString();

  /* State used by the login/register component at the bottom for when no user is logged in */

  const [userFormState, setUserFormState] = useState(1);

  function setFormStep(input) {
    setUserFormState(input);
  }

  const dispatch = useDispatch();
  const [formReady, setFormReady] = useState(false);
  const [formState, setFormState] = useState(1);
  const [dbFormExists, setDbFormExists] = useState(false);
  /* const [formSaved, setFormSaved] = useState(false); */
  const [formSavedButtonStatus, setFormSavedButtonStatus] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { userInfo } = useSelector((state) => state.userLogin);
  const smeDetails = useSelector((state) => state.userSMEDetails);
  const { sme } = smeDetails;
  const [showSubmittedButton, setShowSubmittedButton] = useState(1);

  const [formVars, setFormVars] = useState([
    {
      parentAnswer: null,
      varName: "businessStage",
      value: null,
      index: 0,
      type: "parentMulti",
      category: "regulatory",
      childrenAnswers: {
        ideaStage: false,
        soleTrader: false,
        company: false,
        partnership: false,
      },
    },
    {
      parentAnswer: "ideaStage",
      varName: "haveFound",
      value: null,
      index: 1,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: "soleTrader",
      varName: "regInc",
      value: null,
      index: 2,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: "company",
      varName: "regCipc",
      value: null,
      index: 3,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: "company",
      varName: "haveMoi",
      value: null,
      index: 4,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: "partnership",
      varName: "haveMoi",
      value: null,
      index: 5,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "have1Mill",
      value: null,
      index: 6,
      type: "parentYesNo",
      category: "regulatory",
      childrenAnswers: {
        have1Mill: false,
      },
    },
    {
      parentAnswer: "have1Mill",
      varName: "regVat",
      value: null,
      index: 7,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "haveEmployees",
      value: null,
      index: 8,
      type: "parentYesNo",
      category: "regulatory",
      childrenAnswers: {
        haveEmployees: false,
      },
    },
    {
      parentAnswer: "haveEmployees",
      varName: "regUif",
      value: null,
      index: 9,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "regPaye",
      value: null,
      index: 10,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "docPaia",
      value: null,
      index: 11,
      type: "standalone",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "haveInfoOff",
      value: null,
      index: 12,
      type: "standalone",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "haveWebsite",
      value: null,
      index: 13,
      type: "parentYesNo",
      category: "regulatory",
      childrenAnswers: { haveWebsite: false },
    },
    {
      parentAnswer: "haveWebsite",
      varName: "docTandC",
      value: null,
      index: 14,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveWebsite",
      varName: "docPriPo",
      value: null,
      index: 15,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: "company",
      varName: "haveShare",
      value: null,
      index: 16,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: "company",
      varName: "docBoardRes",
      value: null,
      index: 17,
      type: "child",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "webGaS",
      value: null,
      index: 18,
      type: "standalone",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "webSaaS",
      value: null,
      index: 19,
      type: "standalone",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "empType",
      value: null,
      index: 20,
      type: "parentChildYesNo",
      category: "internal",
      childrenAnswers: {
        empType: false,
      },
    },
    {
      parentAnswer: "haveEmployees",
      varName: "empContract",
      value: null,
      index: 21,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "empType",
      varName: "empSubType",
      value: null,
      index: 22,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "docPolicyOHS",
      value: null,
      index: 23,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "docPolicySexHar",
      value: null,
      index: 24,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "docPolicyDisc",
      value: null,
      index: 25,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "docPolicyAbs",
      value: null,
      index: 26,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "docPolicyAlcDru",
      value: null,
      index: 27,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "docPolicyDiscrim",
      value: null,
      index: 28,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "docPolicyInc",
      value: null,
      index: 29,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "docPolicyGriev",
      value: null,
      index: 30,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: "haveEmployees",
      varName: "remoteWorkers",
      value: null,
      index: 31,
      type: "parentChildYesNo",
      category: "internal",
      childrenAnswers: {
        remoteWorkers: false,
      },
    },
    {
      parentAnswer: "remoteWorkers",
      varName: "docPolicyRemote",
      value: null,
      index: 32,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "designedInvention",
      value: null,
      index: 33,
      type: "parentYesNo",
      category: "internal",
      childrenAnswers: { designedInvention: false },
    },
    {
      parentAnswer: "designedInvention",
      varName: "docIpProtection",
      value: null,
      index: 34,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "docNDA",
      value: null,
      index: 35,
      type: "standalone",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "docIpDisclaimer",
      value: null,
      index: 36,
      type: "standalone",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "rentPremises",
      value: null,
      index: 37,
      type: "parentYesNo",
      category: "internal",
      childrenAnswers: { rentPremises: false },
    },
    {
      parentAnswer: "rentPremises",
      varName: "docLease",
      value: null,
      index: 38,
      type: "child",
      category: "internal",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "docToTrade",
      value: null,
      index: 39,
      type: "standalone",
      category: "external",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "docSupAg",
      value: null,
      index: 40,
      type: "standalone",
      category: "external",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "docWarranties",
      value: null,
      index: 41,
      type: "standalone",
      category: "external",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "docToService",
      value: null,
      index: 42,
      type: "standalone",
      category: "external",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "haveCyber",
      value: null,
      index: 43,
      type: "standalone",
      category: "regulatory",
      childrenAnswers: null,
    },
    {
      parentAnswer: null,
      varName: "test",
      value: null,
      index: 44,
      type: "standalone",
      category: "regulatory",
      childrenAnswers: null,
    },
  ]);

  useEffect(() => {
    dispatch(getUserSMEDetails());
    console.log("fetched sme details");
  }, [dispatch]);

  // Get metrics from DB if any and set form array with them
  useEffect(() => {
    /* console.log("userInfo", userInfo); */
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };
    axios
      .get("/api/health-check/get-metrics/", config)
      .then(function (response) {
        // get saved form array from db
        const form = response.data.metrics;
        setDbFormExists(true);
        // turn it from string back into object
        const preparedForm = JSON.parse(form);
        const formVarsCopy = formVars;
        for (var i = 0; i < preparedForm.length; i++) {
          if (preparedForm[i].value !== null) {
            formVarsCopy[i] = preparedForm[i];
          }
        }
        /* console.log("formVarsCopy", formVarsCopy); */

        setFormVars((oldFormVars) => [...formVarsCopy]);
      })
      .catch(function (error) {
        console.log("error");
      });
    // eslint-disable-next-line
  }, [userInfo]);

  function submitFormStep(e) {
    const newFormVars = formVars;
    // Look for item whose varName matches "name" attr of form step
    newFormVars.forEach((item) => {
      if (item.varName === e.target.name) {
        // Once match is found, change childrenAnswer matching
        // "value" attribute of selected form option from false to true
        // and set all others back to false
        if (item.type === "parentMulti") {
          item.value = e.target.value;
          for (const key in item.childrenAnswers) {
            if (key === e.target.value) {
              item.childrenAnswers[key] = true;
            } else {
              item.childrenAnswers[key] = false;
            }
            //   console.log(item.childrenAnswers[key]);
          }
        } else if (item.type === "child") {
          if (item.parentAnswer === e.target.getAttribute("data-parent")) {
            if (e.target.value === "true") {
              item.value = true;
            } else if (e.target.value === "false") {
              item.value = false;
            } else {
              item.value = e.target.value;
            }
          }
        } else if (item.type === "parentYesNo") {
          if (e.target.value === "true") {
            item.value = true;
          } else if (e.target.value === "false") {
            item.value = false;
          }
          for (const key in item.childrenAnswers) {
            if (e.target.value === "true") {
              item.childrenAnswers[key] = true;
            } else if (e.target.value === "false") {
              item.value = false;
              item.childrenAnswers[key] = false;
            }
            //   console.log(item.childrenAnswers[key]);
          }
        } else if (item.type === "parentChildYesNo") {
          if (e.target.value === "true") {
            item.value = true;
          } else if (e.target.value === "false") {
            item.value = false;
          }
          for (const key in item.childrenAnswers) {
            if (e.target.value === "true") {
              item.childrenAnswers[key] = true;
            } else if (e.target.value === "false") {
              item.childrenAnswers[key] = false;
            }
          }
        } else if (item.type === "standalone") {
          if (e.target.value === "true") {
            item.value = true;
          } else if (e.target.value === "false") {
            item.value = false;
          }
        }
      }
    });

    setFormVars((old) => [...newFormVars]);
    /*  console.log("newFormVars", newFormVars); */
  }

  // Send a put request with updated form vars to db
  function save() {
    setFormSavedButtonStatus((old) => !old);
    setTimeout(() => setFormSavedButtonStatus((old) => !old), 1000);
    // Make all children with deselected parent values back to null
    const formVarsCopy = formVars;
    formVarsCopy.forEach((firstLoopItem) => {
      // if you find a parent question
      if (firstLoopItem.type !== "child") {
        // look through its children answers
        for (const key in firstLoopItem.childrenAnswers) {
          // if you find a false value in childern answers
          if (firstLoopItem.childrenAnswers[key] === false) {
            // loop through array again
            formVarsCopy.forEach((secondLoopItem) => {
              // console.log(
              //   "secondLoopItem.parentAnswer",
              //   secondLoopItem.parentAnswer
              // );
              // console.log("key", key);
              if (secondLoopItem.parentAnswer === key) {
                secondLoopItem.value = null;
              }
            });
          }
        }
      }
    });
    /* console.log("formVarsCopy", formVarsCopy); */
    const stringForm = JSON.stringify(formVarsCopy);
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };
    if (dbFormExists) {
      console.log("sending put request");
      axios
        .put(
          "/api/health-check/update-metrics/",
          {
            metrics: stringForm,
          },
          config
        )
        .then(function (response) {
          console.log("Response Received");
        })
        .catch(function (error) {
          console.log("Error Occured");
        });
    } else {
      console.log("sending post request");
      axios
        .post(
          "/api/health-check/add-metrics/",
          {
            metrics: stringForm,
          },
          config
        )
        .then(function (response) {
          console.log("Response Received");
        })
        .catch(function (error) {
          console.log("Error Occured");
        });
      setDbFormExists(true);
    }
    /* This FormSaved variable is not used anywhere else so commented out */
    /* setFormSaved(true); */
  }

  function submit() {
    save();
    const api_secret_key = "TDNMSwa7U1p56gg6gEnH";
    // eslint-disable-next-line
    const doc_template_id = "7CB28FF9-1704-41AC-BEB9-D217A5AB45DB";
    const doctype_id = "LAC_V1.5 - LEGAL HEALTH CHECK";
    const formVarsCopy = formVars;
    const payloadVar = {};
    const cleanForm = {
      regulatoryCompliance: {},
      internalOperations: {},
      externalOperations: {},
    };
    var regulatoryComplianceScores = 0;
    var internalOperationsScores = 0;
    var externalOperationsScores = 0;
    var regulatoryComplianceTotal = 0;
    var internalOperationsTotal = 0;
    var externalOperationsTotal = 0;
    var totalScore = 0;

    /* Hides Submit button after a user has sumbitted. */
    setShowSubmittedButton(2);
    /* console.log(showSubmittedButton); */

    // Add all children vars with non-null values to cleanForm
    formVarsCopy.forEach((item) => {
      // all items that depend on parents

      if (
        item.type !== "parentMulti" &&
        item.type !== "parentYesNo" &&
        item.type !== "parentChildYesNo"
      ) {
        if (item.value !== null) {
          if (item.category === "internal") {
            cleanForm.internalOperations[item.varName] = item.value;
          } else if (item.category === "external") {
            cleanForm.externalOperations[item.varName] = item.value;
          } else if (item.category === "regulatory") {
            cleanForm.regulatoryCompliance[item.varName] = item.value;
          }
          // console.log("cleanForm[item.varName]", cleanForm[item.varName]);
          // console.log("item.value", item.value);
          // cleanForm[item.varName] = item.value;
        }
      }
    });

    // sum up scores
    for (const key in cleanForm) {
      /* console.log("key", key); */
      if (key === "regulatoryCompliance") {
        var length = Object.keys(cleanForm[key]).length;
        /* console.log("length", length); */
        for (const nextKey in cleanForm[key]) {
          /* console.log("nextKey", cleanForm[key][nextKey]); */
          if (cleanForm[key][nextKey] === true) {
            regulatoryComplianceScores += 1;
          }
        }
        if (regulatoryComplianceScores !== 0) {
          regulatoryComplianceTotal = Math.round(
            (regulatoryComplianceScores / length) * 100
          );
        } else {
          regulatoryComplianceTotal = 0;
        }
        /* console.log("regulatoryComplianceTotal", regulatoryComplianceTotal); */
      } else if (key === "internalOperations") {
        // eslint-disable-next-line
        var length = Object.keys(cleanForm[key]).length;
        for (const nextKey in cleanForm[key]) {
          if (cleanForm[key][nextKey] === true) {
            internalOperationsScores += 1;
          }
        }
        if (internalOperationsScores !== 0) {
          internalOperationsTotal = Math.round(
            (internalOperationsScores / length) * 100
          );
        } else {
          internalOperationsTotal = 0;
        }
        /* console.log("internalOperationsTotal", internalOperationsTotal); */
      } else if (key === "externalOperations") {
        // eslint-disable-next-line
        var length = Object.keys(cleanForm[key]).length;
        for (const nextKey in cleanForm[key]) {
          if (cleanForm[key][nextKey] === true) {
            externalOperationsScores += 1;
          }
        }
        if (externalOperationsScores !== 0) {
          externalOperationsTotal = Math.round(
            (externalOperationsScores / length) * 100
          );
        } else {
          externalOperationsTotal = 0;
        }
        /* console.log("externalOperationsTotal", externalOperationsTotal); */
      }
    }
    totalScore = Math.round(
      ((externalOperationsTotal +
        internalOperationsTotal +
        regulatoryComplianceTotal) /
        300) *
        100
    );
    /*  console.log(totalScore); */

    formVars.forEach((item) => {
      payloadVar[item.varName] = item.value;
    });

    payloadVar["externalOperationsTotal"] = externalOperationsTotal;
    payloadVar["internalOperationsTotal"] = internalOperationsTotal;
    payloadVar["regulatoryComplianceTotal"] = regulatoryComplianceTotal;
    payloadVar["totalScore"] = totalScore;
    payloadVar["userId"] = userInfo.id;
    payloadVar["company_id"] = userInfo.email;
    payloadVar["doctype_id"] = doctype_id;
    payloadVar["company_name"] = sme.name;
    payloadVar["name"] = userInfo.name;
    

    // externalOperationsTotal = 20;
    // internalOperationsTotal = 40;
    // regulatoryComplianceTotal = 49;
    // totalScore = 40;
    // console.log("payload", payloadVar);
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };
    axios
      .put(
        "/api/documents/update-health-metrics/",
        {
          externalOperationsTotal: externalOperationsTotal,
          internalOperationsTotal: internalOperationsTotal,
          regulatoryComplianceTotal: regulatoryComplianceTotal,
          totalScore: totalScore,
        },
        config
      )
      .then(function (response) {
        console.log("Response Received");
      })
      .catch(function (error) {
        console.log("Error Occured");
      });

    axios
      .put(
        "/api/users/health-check-date-update/",
        {
          date: date,
        },
        config
      )
      .then(function (response) {
        console.log("Response Received");
      })
      .catch(function (error) {
        console.log("Error Occured");
      });

    const pdfMonkeyConfig = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${api_secret_key}`,
      },
    };

    axios
      .post(
        "https://api.pdfmonkey.io/api/v1/documents/",
        {
          document: {
            document_template_id: "1BFBD125-71C8-439A-88E0-794FDA27DAC9",
            payload: payloadVar,
            status: "pending",
          },
        },
        pdfMonkeyConfig
      )
      .then(function (response) {
        console.log("Response Received");
      })
      .catch(function (error) {
        console.log("Error Occured");
      });
    /*  console.log("payloadVar", payloadVar);
    console.log("cleanForm", cleanForm); */
    setFormSubmitted(true);
  }

  /* console.log("formVars", formVars);
  console.log("dbformexists", dbFormExists); */

  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      <Helmet>
        <title>Legal Health Check</title>
        <meta
          name="description"
          content="Lacoona Legals library of products, Guided Documents and Legal Flows to aid you in the development and management of your business"
        />
        <link rel="canonical" href="/dashboard/health-check" />
      </Helmet>
      <DashHeader pageTitle={"Health check"} />
      {/* showHealtcheck ==true && form */}
      {userInfo && userFormState === 1 ? (
        <Row className="dashboard-content-container">
          <LinkContainer to={"/dashboard/legal-checks"}>
            <button className="lcn-button-orange back py-2 px-4">Back</button>
          </LinkContainer>
          <h2 className="ll-feat-font mt-5">Your Legal Health Check</h2>
          <Row className="health-check-form-row mx-1 mb-5">
            <Col className="health-check-form-col">
              {/* Regulatory compliance ********************* */}
              <Row className="health-check-form-categories">
                <Col
                  onClick={() => setFormState(1)}
                  className={formState === 1 ? "active-tab" : "tab"}
                >
                  <div>Regulatory Compliance</div>
                </Col>
                <Col
                  onClick={() => setFormState(2)}
                  className={formState === 2 ? "active-tab" : "tab"}
                >
                  <div>Internal Operations</div>
                </Col>
                <Col
                  onClick={() => setFormState(3)}
                  className={formState === 3 ? "active-tab" : "tab"}
                >
                  <div>External Operations</div>
                </Col>
              </Row>
              <Row className="health-check-form">
                {formState === 1 && (
                  <Col className="health-check-form-step">
                    <h5>Basic Compliance</h5>
                    <Form>
                      <Form.Group>
                        <Form.Label>
                          Please select the most appropriate type of
                          organisation.
                        </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="businessStage"
                          className="mb-3"
                          // defaultValue={"DEFAULT"}
                          value={
                            formVars[0].value ? formVars[0].value : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="ideaStage">Idea Stage</option>
                          <option value="soleTrader">Sole Trader</option>
                          <option value="company">Company</option>
                          <option value="partnership">Partnership</option>
                        </Form.Select>
                      </Form.Group>
                      {formVars[0].childrenAnswers["ideaStage"] && (
                        <Form.Group>
                          <Form.Label>
                            Do you have a Founders Agreement
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="haveFound"
                            className="mb-3"
                            value={
                              formVars[1].value === true
                                ? formVars[1].value
                                : formVars[1].value === false
                                ? formVars[1].value
                                : "DEFAULT"
                            }
                            data-parent="ideaStage"
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                      )}
                      {formVars[0].childrenAnswers["soleTrader"] && (
                        <Form.Group>
                          <Form.Label>
                            Are you registered for Income Tax?{" "}
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="regInc"
                            className="mb-3"
                            value={
                              formVars[2].value === true
                                ? formVars[2].value
                                : formVars[2].value === false
                                ? formVars[2].value
                                : "DEFAULT"
                            }
                            data-parent="soleTrader"
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                      )}
                      {formVars[0].childrenAnswers["company"] && (
                        <div>
                          <Form.Group>
                            <Form.Label>
                              Are you registered with CIPC?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="regCipc"
                              className="mb-3"
                              value={
                                formVars[3].value === true
                                  ? formVars[3].value
                                  : formVars[3].value === false
                                  ? formVars[3].value
                                  : "DEFAULT"
                              }
                              data-parent="company"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>
                              Do you have a Memorandum of Incorporation?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="haveMoi"
                              className="mb-3"
                              value={
                                formVars[4].value === true
                                  ? formVars[4].value
                                  : formVars[4].value === false
                                  ? formVars[4].value
                                  : "DEFAULT"
                              }
                              data-parent="company"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                        </div>
                      )}
                      {formVars[0].childrenAnswers["partnership"] && (
                        <Form.Group>
                          <Form.Label>
                            Do you have a partnership Agreement?
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="haveMoi"
                            className="mb-3"
                            value={
                              formVars[5].value === true
                                ? formVars[5].value
                                : formVars[5].value === false
                                ? formVars[5].value
                                : "DEFAULT"
                            }
                            data-parent="partnership"
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                      )}

                      <Form.Group>
                        <Form.Label>
                          Do you have a turnover of over one million rand per
                          year?
                        </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="have1Mill"
                          className="mb-3"
                          value={
                            formVars[6].value === true
                              ? formVars[6].value
                              : formVars[6].value === false
                              ? formVars[6].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      {formVars[6].childrenAnswers["have1Mill"] && (
                        <Form.Group>
                          <Form.Label>Are you registered for VAT?</Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="regVat"
                            className="mb-3"
                            value={
                              formVars[7].value === true
                                ? formVars[7].value
                                : formVars[7].value === false
                                ? formVars[7].value
                                : "DEFAULT"
                            }
                            data-parent="have1Mill"
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                      )}

                      <Form.Group>
                        <Form.Label>Do you have employees?</Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="haveEmployees"
                          className="mb-3"
                          value={
                            formVars[8].value === true
                              ? formVars[8].value
                              : formVars[8].value === false
                              ? formVars[8].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      {formVars[8].childrenAnswers["haveEmployees"] && (
                        <div>
                          <Form.Group>
                            <Form.Label>
                              Are you registered for Unemployement Insurance
                              Fund?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="regUif"
                              className="mb-3"
                              value={
                                formVars[9].value === true
                                  ? formVars[9].value
                                  : formVars[9].value === false
                                  ? formVars[9].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>
                              Are you registered for Pay as You Earn?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="regPaye"
                              className="mb-3"
                              value={
                                formVars[10].value === true
                                  ? formVars[10].value
                                  : formVars[10].value === false
                                  ? formVars[10].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                        </div>
                      )}
                      <Form.Group>
                        <Form.Label>Do you have a PAIA Manual?</Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="docPaia"
                          className="mb-3"
                          value={
                            formVars[11].value === true
                              ? formVars[11].value
                              : formVars[11].value === false
                              ? formVars[11].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>
                          Do you have an information officer?
                        </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="haveInfoOff"
                          className="mb-3"
                          value={
                            formVars[12].value === true
                              ? formVars[12].value
                              : formVars[12].value === false
                              ? formVars[12].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>
                          Have you and your employees completed cybersecurity
                          training?
                        </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="haveCyber"
                          className="mb-3"
                          value={
                            formVars[43].value === true
                              ? formVars[43].value
                              : formVars[43].value === false
                              ? formVars[43].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Do you have a website?</Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="haveWebsite"
                          className="mb-3"
                          value={
                            formVars[13].value === true
                              ? formVars[13].value
                              : formVars[13].value === false
                              ? formVars[13].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      {formVars[13].childrenAnswers["haveWebsite"] && (
                        <div>
                          <Form.Group>
                            <Form.Label>
                              Do you have website Terms of Use?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docTandC"
                              className="mb-3"
                              value={
                                formVars[14].value === true
                                  ? formVars[14].value
                                  : formVars[14].value === false
                                  ? formVars[14].value
                                  : "DEFAULT"
                              }
                              data-parent="haveWebsite"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>
                              Do you have a website privacy policy?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docPriPo"
                              className="mb-3"
                              value={
                                formVars[15].value === true
                                  ? formVars[15].value
                                  : formVars[15].value === false
                                  ? formVars[15].value
                                  : "DEFAULT"
                              }
                              data-parent="haveWebsite"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                        </div>
                      )}
                      {formVars[0].childrenAnswers["company"] && (
                        <div>
                          <hr />
                          <h5>Board and Corporate</h5>

                          <Form.Group>
                            <Form.Label>
                              Does your company have more than one shareholder?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="haveShare"
                              className="mb-3"
                              value={
                                formVars[16].value === true
                                  ? formVars[16].value
                                  : formVars[16].value === false
                                  ? formVars[16].value
                                  : "DEFAULT"
                              }
                              data-parent="company"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>
                              Do you know how to pass a board resoluton?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docBoardRes"
                              className="mb-3"
                              value={
                                formVars[17].value === true
                                  ? formVars[17].value
                                  : formVars[17].value === false
                                  ? formVars[17].value
                                  : "DEFAULT"
                              }
                              data-parent="company"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                        </div>
                      )}
                    </Form>
                    <button
                      className="lcn-button-orange health-form-button-next"
                      onClick={() => setFormState(2)}
                    >
                      Next
                    </button>
                  </Col>
                )}
                {formState === 2 && (
                  <Col className="health-check-form-step">
                    <Form>
                      <h5>Website</h5>
                      <Form.Group>
                        <Form.Label>
                          Are there goods and services sold through your
                          website/app?
                        </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="webGaS"
                          className="mb-3"
                          value={
                            formVars[18].value === true
                              ? formVars[18].value
                              : formVars[18].value === false
                              ? formVars[18].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>
                          Do you operate an application software as a part of
                          your business?
                        </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="webSaaS"
                          className="mb-3"
                          value={
                            formVars[19].value === true
                              ? formVars[19].value
                              : formVars[19].value === false
                              ? formVars[19].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      {formVars[8].childrenAnswers["haveEmployees"] && (
                        <div>
                          <hr />
                          <h5>Employment</h5>
                          <Form.Group>
                            <Form.Label>
                              Do you have any permanent employees?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="empType"
                              className="mb-3"
                              value={
                                formVars[20].value === true
                                  ? formVars[20].value
                                  : formVars[20].value === false
                                  ? formVars[20].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                        </div>
                      )}
                      {formVars[20].childrenAnswers["empType"] && (
                        <Form.Group>
                          <Form.Label>
                            Are your permanent employees full time, part time,
                            or flexi?
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="empSubType"
                            className="mb-3"
                            value={
                              formVars[22].value
                                ? formVars[22].value
                                : "DEFAULT"
                            }
                            data-parent="empType"
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="Full-time">Full-time</option>
                            <option value="Part-time">Part-time</option>
                            <option value="Flexi">Flexi</option>
                          </Form.Select>
                        </Form.Group>
                      )}
                      {formVars[8].childrenAnswers["haveEmployees"] && (
                        <div>
                          <Form.Group>
                            <Form.Label>
                              Do you have employment contracts for all your
                              employees?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="empContract"
                              className="mb-3"
                              value={
                                formVars[21].value === true
                                  ? formVars[21].value
                                  : formVars[21].value === false
                                  ? formVars[21].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>

                          <Form.Group>
                            <Form.Label>
                              Do you have a Health and Safety Policy?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docPolicyOHS"
                              className="mb-3"
                              value={
                                formVars[23].value === true
                                  ? formVars[23].value
                                  : formVars[23].value === false
                                  ? formVars[23].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>
                              Do you have a Sexual Harassment Policy?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docPolicySexHar"
                              className="mb-3"
                              value={
                                formVars[24].value === true
                                  ? formVars[24].value
                                  : formVars[24].value === false
                                  ? formVars[24].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>
                              Do you have a Disciplinary Policy?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docPolicyDisc"
                              className="mb-3"
                              value={
                                formVars[25].value === true
                                  ? formVars[25].value
                                  : formVars[25].value === false
                                  ? formVars[25].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>
                              Do you have an Absenteeism Policy?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docPolicyAbs"
                              className="mb-3"
                              value={
                                formVars[26].value === true
                                  ? formVars[26].value
                                  : formVars[26].value === false
                                  ? formVars[26].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>
                              Do you have an Alcohol and Drug Use Policy?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docPolicyAlcDru"
                              className="mb-3"
                              value={
                                formVars[27].value === true
                                  ? formVars[27].value
                                  : formVars[27].value === false
                                  ? formVars[27].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>

                          <Form.Group>
                            <Form.Label>
                              Do you have a Discrimination Policy?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docPolicyDiscrim"
                              className="mb-3"
                              value={
                                formVars[28].value === true
                                  ? formVars[28].value
                                  : formVars[28].value === false
                                  ? formVars[28].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>
                              Do you have an Incapacity Policy?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docPolicyInc"
                              className="mb-3"
                              value={
                                formVars[29].value === true
                                  ? formVars[29].value
                                  : formVars[29].value === false
                                  ? formVars[29].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>
                              Do you have a Grievance Policy?
                            </Form.Label>
                            <Form.Select
                              onChange={submitFormStep}
                              name="docPolicyGriev"
                              className="mb-3"
                              value={
                                formVars[30].value === true
                                  ? formVars[30].value
                                  : formVars[30].value === false
                                  ? formVars[30].value
                                  : "DEFAULT"
                              }
                              data-parent="haveEmployees"
                            >
                              <option value="DEFAULT" disabled>
                                Choose a value
                              </option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </Form.Select>
                          </Form.Group>
                        </div>
                      )}
                      <Form.Group>
                        <Form.Label>
                          Do you have any remote working employees?
                        </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="remoteWorkers"
                          className="mb-3"
                          value={
                            formVars[31].value === true
                              ? formVars[31].value
                              : formVars[31].value === false
                              ? formVars[31].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      {formVars[31].childrenAnswers["remoteWorkers"] && (
                        <Form.Group>
                          <Form.Label>
                            Do you have policies/procedures for office-based and
                            remote-working staff?
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="docPolicyRemote"
                            className="mb-3"
                            value={
                              formVars[32].value === true
                                ? formVars[32].value
                                : formVars[32].value === false
                                ? formVars[32].value
                                : "DEFAULT"
                            }
                            data-parent="remoteWorkers"
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                      )}
                      <hr />
                      <h5>Intellectual Property</h5>
                      <Form.Group>
                        <Form.Label>
                          Have you designed, created, or developed any invention
                          or product design that is used in your business?
                        </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="designedInvention"
                          className="mb-3"
                          value={
                            formVars[33].value === true
                              ? formVars[33].value
                              : formVars[33].value === false
                              ? formVars[33].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      {formVars[33].childrenAnswers["designedInvention"] && (
                        <Form.Group>
                          <Form.Label>
                            Do you have trademarks, patents, design registration
                            or copyright disclaimers?
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="docIpProtection"
                            className="mb-3"
                            value={
                              formVars[34].value === true
                                ? formVars[34].value
                                : formVars[34].value === false
                                ? formVars[34].value
                                : "DEFAULT"
                            }
                            data-parent="designedInvention"
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                      )}
                      <Form.Group>
                        <Form.Label>
                          Do you have a standardised Non-disclosure Agreement?
                        </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="docNDA"
                          className="mb-3"
                          value={
                            formVars[35].value === true
                              ? formVars[35].value
                              : formVars[35].value === false
                              ? formVars[35].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>
                          Do you have a written agreement in place with the
                          company or person which creates/created the outsourced
                          works, regulating your relationship, and which states
                          that the ownership of any intellectual property that
                          they create is transferred back to you?{" "}
                        </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="docIpDisclaimer"
                          className="mb-3"
                          value={
                            formVars[36].value === true
                              ? formVars[36].value
                              : formVars[36].value === false
                              ? formVars[36].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      <hr />
                      <h5>Property</h5>
                      <Form.Group>
                        <Form.Label>Do you rent your premises? </Form.Label>
                        <Form.Select
                          onChange={submitFormStep}
                          name="rentPremises"
                          className="mb-3"
                          value={
                            formVars[37].value === true
                              ? formVars[37].value
                              : formVars[37].value === false
                              ? formVars[37].value
                              : "DEFAULT"
                          }
                        >
                          <option value="DEFAULT" disabled>
                            Choose a value
                          </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </Form.Group>
                      {formVars[37].childrenAnswers["rentPremises"] && (
                        <Form.Group>
                          <Form.Label>
                            Do you have a written lease in place with your
                            landlord?
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="docLease"
                            className="mb-3"
                            value={
                              formVars[38].value === true
                                ? formVars[38].value
                                : formVars[38].value === false
                                ? formVars[38].value
                                : "DEFAULT"
                            }
                            data-parent="rentPremises"
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                      )}
                    </Form>
                    <button
                      className="lcn-button-orange health-form-button-back"
                      onClick={() => setFormState(1)}
                    >
                      Back
                    </button>
                    <button
                      className="lcn-button-orange health-form-button-next"
                      onClick={() => setFormState(3)}
                    >
                      Next
                    </button>
                  </Col>
                )}
                {formState === 3 && (
                  <Col className="health-check-form-step">
                    <Form>
                      <h5>Supplier</h5>
                      <div>
                        <Form.Group>
                          <Form.Label>
                            Do you have up to date Terms of Trade that covers
                            all contingencies?
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="docToTrade"
                            className="mb-3"
                            value={
                              formVars[39].value === true
                                ? formVars[39].value
                                : formVars[39].value === false
                                ? formVars[39].value
                                : "DEFAULT"
                            }
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>
                            Do you have standardised supply agreements?
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="docSupAg"
                            className="mb-3"
                            value={
                              formVars[40].value === true
                                ? formVars[40].value
                                : formVars[40].value === false
                                ? formVars[40].value
                                : "DEFAULT"
                            }
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                        <hr />
                        <h5>Customer</h5>
                        <Form.Group>
                          <Form.Label>
                            Do you provide product warranties?
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="docWarranties"
                            className="mb-3"
                            value={
                              formVars[41].value === true
                                ? formVars[41].value
                                : formVars[41].value === false
                                ? formVars[41].value
                                : "DEFAULT"
                            }
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>
                            Do you have Terms of Service in place to govern the
                            relationship between you and your customers?
                          </Form.Label>
                          <Form.Select
                            onChange={submitFormStep}
                            name="docToService"
                            className="mb-3"
                            value={
                              formVars[42].value === true
                                ? formVars[42].value
                                : formVars[42].value === false
                                ? formVars[42].value
                                : "DEFAULT"
                            }
                          >
                            <option value="DEFAULT" disabled>
                              Choose a value
                            </option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </Form.Select>
                        </Form.Group>
                      </div>
                    </Form>
                    <button
                      className="lcn-button-orange health-form-button-back"
                      onClick={() => setFormState(2)}
                    >
                      Back
                    </button>
                  </Col>
                )}
              </Row>
              <Row>
                <Col
                  className="my-5 py-3 px-1 mx-5 health-check-save-text ll-card-interact"
                  align="center"
                >
                  <Col align="center">
                    <h5 className="ll-health-check-submit-text">
                      If you can't finish filling in your form, click save and
                      come back to it later.
                    </h5>
                  </Col>

                  <Col className="ll-health-button-container" align="center">
                    <button
                      className="lcn-button-orange health-buttons"
                      onClick={save}
                    >
                      {formSavedButtonStatus ? "Save" : "Saving"}
                    </button>
                  </Col>
                </Col>

                {!formReady && (
                  <Col className="my-5 mx-5 p-3 ll-card-interact health-check-save-text">
                    <Col
                      className="my-2 ll-health-button-container"
                      align="center"
                    >
                      <h5 className="ll-health-check-submit-text">
                        Click below to submit your form. Only do this once you
                        have answered all questions.
                      </h5>
                    </Col>
                    <Col align="center">
                      <button
                        className="lcn-button-orange health-buttons"
                        onClick={() => setFormReady((oldState) => !oldState)}
                      >
                        Submit
                      </button>
                    </Col>
                  </Col>
                )}
                {showSubmittedButton === 1
                  ? formReady && (
                      <Col className="my-5 mx-5 p-3 health-check-save-text ll-card-interact">
                        <Col className="my-2" align="center">
                          <h5 className="ll-health-check-submit-text">
                            Are you sure you have completed all relevant
                            questions?
                          </h5>
                        </Col>
                        <Col
                          align="center"
                          className="ll-health-button-container"
                        >
                          <button
                            className="lcn-button-orange health-buttons"
                            onClick={submit}
                          >
                            Yes, submit
                          </button>
                        </Col>
                      </Col>
                    )
                  : formSubmitted && (
                      <Col
                        className="my-5 mx-5 p-3 ll-card-interact health-check-save-text"
                        align="center"
                      >
                        <Row
                          className="my-2 ll-health-check-submit-text"
                          align="center"
                        >
                          <h5 className="ll-health-check-submit-text">
                            Thank you for submitting your form. Please go to
                            your dashboard to view your health metrics.
                          </h5>
                        </Row>
                      </Col>
                    )}
              </Row>
            </Col>
          </Row>
        </Row>
      ) : (
        <Row className="dashboard-content-container">
          <div>
            {/* Note that set form step is a function. Allows changing of the form step.
             */}
            {userFormState === 1 && <LoginComp setFormStep={setFormStep} />}
            {userFormState === 2 && <RegComp setFormStep={setFormStep} />}
            {userFormState === 3 && (
              <RegCompSME
                setFormStep={setFormStep}
                redirectPost={`/dashboard/health-check`}
              />
            )}
          </div>
        </Row>
      )}
    </Col>
  );
}

export default HealthCheckForm3;
